import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDE-gSA4dVklGu6fFZPaxwc2BRnghGoT1M",
  authDomain: "coredeck-90a56.firebaseapp.com",
  projectId: "coredeck-90a56",
  storageBucket: "coredeck-90a56.firebasestorage.app",
  messagingSenderId: "512734234660",
  appId: "1:512734234660:web:ae57cdc83aa501509e30b1",
  measurementId: "G-WJTQFDZ1FJ",
};

export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// DEPLOYED callable functions (region must match)
export const functions = getFunctions(app, "us-central1");

const persistenceReady = setPersistence(auth, browserLocalPersistence).catch(() => {});

export const authReady = (async () => {
  await persistenceReady;
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      resolve(user);
    });
  });
})();

export default app;
